// Shared Imports
import { IEnvironment, EEnvironment } from '@shared/models'

export const environment: IEnvironment = {
	production: true,
	operationGatewayMexico: 'https://zeegw.vemo.mx/oms/mex',
	gateway: 'https://zeegw.vemo.mx',
	environment: EEnvironment.prod,
	signinRedirectUrl: 'https://zeeoperation.vemo.mx',
	signoutRedirectUrl: 'https://zeeoperation.vemo.mx/logout',
}
